import styled from 'styled-components';

/**
 * The MUI field is transparent by default, so it takes the grey of whatever sits behind it and
 * looks disabled when empty: it gets the same white background as the neighboring Inpulse fields.
 */
export const Container = styled.div`
  & .MuiOutlinedInput-root {
    background: ${({ theme }) => theme.colors.greys.lightest};
  }
`;
